import React, { useState } from "react";

import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import { AppBar, Tab } from "@material-ui/core";

import ConfigBackupList from "./ConfigBackupList";
import PortForwardingBackup from "./PortForwardingBackup";

const TABS = {
  configBackup: "configbackup",
  pfBackup: "pfbackup",
};

const DeviceConfiguration = (props) => {
  const [tabValue, setTabValue] = useState(TABS.configBackup);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <>
      <TabContext value={tabValue}>
        <AppBar position="static">
          <TabList onChange={handleChange} aria-label="configuration tabs">
            <Tab label="Config Backups" value={TABS.configBackup} />
            <Tab label="Port Forwarding Backup" value={TABS.pfBackup} />
          </TabList>
        </AppBar>
        <TabPanel value={TABS.configBackup}>
          <ConfigBackupList
            deviceUuid={props.deviceUuid}
            setError={props.setError}
            setMessage={props.setMessage}
          />
        </TabPanel>
        <TabPanel value={TABS.pfBackup}>
          <PortForwardingBackup
            deviceUuid={props.deviceUuid}
            setError={props.setError}
            setMessage={props.setMessage}
          />
        </TabPanel>
      </TabContext>
    </>
  );
};

export default DeviceConfiguration;
